import { FC } from 'react';
import { Table, TableRow, TBody, TD, TH, THead } from '@/components/DesignLibrary/Table';
import Button from '@/components/DesignLibrary/Button';
import Shimmer from '@/components/Shimmer';
import s from './ConnectedDataPanel.module.scss';
import AutofillData from './AutofillData';

type Props = {
  data?: {
    title: string;
    values: { property: string; value: string }[];
    onEditClick?: () => void;
    onClose?: () => void;
    type?: 'autofill' | 'ai-autofill' | 'questionnaire';
  };
  isLoading?: boolean;
};

const DynamicDataPanel: FC<Props> = ({ data, isLoading = false }) => {
  const type = data?.type || 'questionnaire';

  return (
    <aside className={s.panel}>
      {
        !isLoading
          ? (
            <>
              {
                type === 'questionnaire' && (
                  <div className={s.card}>
                    {data?.title && <p className="body-md-bold">{data?.title}</p>}
                    {data?.onEditClick && (
                      <Button variant="secondary" size="xs" onClick={data.onEditClick} className={s.editButton}>
                    Edit
                      </Button>
                    )}
                    <Table>
                      <THead>
                        <TableRow>
                          <TH label="Property" />
                          <TH label="Value" />
                        </TableRow>
                      </THead>
                      <TBody>
                        {data?.values.map(({ property, value }) => (
                          <TableRow key={property}>
                            <TD compact label={property} />
                            <TD compact label={value} />
                          </TableRow>
                        ))}
                      </TBody>
                    </Table>
                  </div>
                )
              }
              {
                (type === 'autofill' || type === 'ai-autofill') && <AutofillData data={data} />
              }
            </>
          )
          : <Shimmer className={s.shimmer} />
      }
    </aside>
  );
};

export default DynamicDataPanel;
